<template>
  <div>
      <index />
  <div class="scrollsidebar" v-if="showButton"  style="display: block;">
    <img src="./assets/top.png" @click="scrollToTop">
    </div>
  </div>
</template>

<script>
import index from "./components/index.vue";
import "bootstrap/dist/css/bootstrap.min.css"; 
export default {
  name: "App",
  components: {
    index,
 },
  data() {
    return {
      showButton: false, // 控制按钮是否显示的属性
      scrollPosition: 0  // 存储当前的滚动位置
    };
  },
  methods: {
    handleScroll() {
      // 获取当前的滚动位置
      this.scrollPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      // 根据滚动位置更新按钮的显示状态
      this.showButton = this.scrollPosition > 0;
    },
    scrollToTop() {
      // 滚动到顶部的功能
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  },
  mounted() {
    // 添加滚动事件监听器
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    // 移除滚动事件监听器
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.scrollsidebar {
  position: fixed; /* 固定定位 */
  bottom: 30px; 
  right: 40px;
  border: none; 
  border-radius: 5px; 
  cursor: pointer; /* 鼠标悬停时显示为手型 */
  z-index: 1000; /* 确保按钮在其他内容之上 */
}
</style>
